import React, { useEffect, useRef } from "react";
import { useNav } from "@/src/hooks";
import clsx from "clsx";
import { NavLink } from "@/src/components";
import { Link } from "@/src/components";
import { socialLinks } from "./social";
import { navLinks } from "./nav";
import logo from "./Reborn_logo_2.png";

export const Sidebar = () => {
  const { isOpen, isMobile, onClose } = useNav();
  const modalRef = useRef(null);

  useEffect(() => {
    const onDocumentClick = (event) => {
      if (!isMobile || !isOpen) return;
      if (modalRef.current?.contains(event.target)) return;
      const buttonEle = document.getElementById("modal-button");
      if (buttonEle?.contains(event.target)) return;
      onClose();
    };

    document.addEventListener("mousedown", onDocumentClick);
    return () => {
      document.removeEventListener("mousedown", onDocumentClick);
    };
  }, [isMobile, isOpen, onClose]);

  return (
    <aside
      ref={modalRef}
      className={clsx(
        "w-[260px] min-w-[260px] flex flex-col h-screen bg-card/80 backdrop-blur-xl border-r border-border text-foreground fixed lg:sticky bottom-0 top-0 overflow-y-auto overflow-x-hidden z-50 transition-transform duration-300 ease-out",
        {
          "translate-x-0": isOpen,
          "-translate-x-full": !isOpen,
        }
      )}
    >
      {/* Logo */}
      <div className="flex justify-center px-6 pt-6 pb-2">
        <img src={logo} className="w-[50%] h-auto opacity-90" alt="Flare Reborn" />
      </div>

      {/* External Links */}
      <div className="px-4 mt-4 space-y-1">
        <a
          target="_blank"
          rel="noreferrer"
          href="https://app.blazeswap.xyz/swap/?inputCurrency=0x1D80c49BbBCd1C0911346656B529DF9E5c2F783d&outputCurrency=0xAAF2eEa8D701EA7d6d328C6a60c4032C9c301EE6"
          className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-secondary/80 transition-all duration-200"
        >
          <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
          </svg>
          <span>Swap</span>
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://app.blazeswap.xyz/pool/add/?tokenA=0x12e605bc104e93B45e1aD99F9e555f659051c2BB&tokenB=0xAAF2eEa8D701EA7d6d328C6a60c4032C9c301EE6"
          className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-secondary/80 transition-all duration-200"
        >
          <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          <span>Manage Liquidity</span>
        </a>
      </div>

      {/* Divider */}
      <div className="h-px bg-border mx-4 my-3" />

      {/* Main Navigation */}
      <nav className="flex-1 px-4 space-y-1">
        {navLinks.map(({ icon, href, label, ...rest }) => (
          <NavLink icon={icon} href={href} key={label} {...rest}>
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="px-4 pb-6 mt-auto">
        <div className="h-px bg-border w-full mb-4" />
        <div className="flex justify-center gap-2">
          {socialLinks.map(({ icon, href }, index) => (
            <Link key={index} href={href}>
              {icon}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
};
